module.exports = __webpack_public_path__ + "static/media/houssein_djirdeh.26caa30c.jpg";